'use client'

import * as React from 'react'
import { HamburgerMenu as HamburgerMenuComponent } from 'components/hamburger-menu'
import { Button } from '@repo/studio-design-system-ui-button'
import { ArrowNarrowRightIcon02, SearchMd02Icon } from 'primitives/icons/general'
import { SearchInput as SearchInputComponent } from 'components/search-input'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { Link } from '@repo/web-ui/components/link'
import dynamic from 'next/dynamic'

const TemplatesSearchWithProvider = dynamic(
  () =>
    import('@repo/studio-components-templates/algolia/search-input').then(
      mod => mod.TemplatesSearchWithProvider,
    ),
  {
    ssr: false,
    loading: () => <SearchInputComponent />,
  },
)

export function SearchMobile({
  placeholderText,
  noResultsText,
  allTemplatesLinkText,
}: {
  placeholderText: string
  noResultsText: string
  allTemplatesLinkText: string
}) {
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <HamburgerMenuComponent
      hasContentFullWidth
      triggerClassName="text-[var(--navigation-menu-hamburger-icon-color)]"
      Icon={
        <SearchMd02Icon
          className="h-6 w-6 text-[var(--navigation-search-icon-color)]"
          style={{ transform: 'translateZ(0)' }}
        />
      }
      controlledOpen={isOpen}
      onOpenChange={setIsOpen}
    >
      <div className="flex w-full flex-1 items-center self-start p-4">
        <TemplatesSearchWithProvider
          searchComponentProps={{
            placeholder: placeholderText,
            containerClassName: 'p-3 border-gray-300 mx-auto bg-transparent',
            className: 'bg-transparent text-gray-500 placeholder-gray-500',
            InputIcon: <SearchMd02Icon className="h-6 w-6 text-gray-500" />,
          }}
          NoResults={
            <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
              <span className="font-semibold text-gray-800">{noResultsText}</span>
              <a
                href={AppRoutes.STUDIO_TEMPLATES}
                className={`flex items-center text-nowrap font-medium text-violet-500`}
              >
                {allTemplatesLinkText}
                <ArrowNarrowRightIcon02 className="ml-1 h-4 w-4" />
              </a>
            </div>
          }
          templatesGalleryRoute={AppRoutes.STUDIO_TEMPLATES}
          templatesItemRoute={AppRoutes.STUDIO_TEMPLATES_ITEM}
          Link={Link}
        />
        <Button variant="ghost" className="text-violet-500" onClick={() => setIsOpen(false)}>
          Cancel
        </Button>
      </div>
    </HamburgerMenuComponent>
  )
}
